import { Button } from 'primereact/button';
import React from 'react';

function BlockDialog({ onHideBlockDialog }) {
    //comment
    return (
        <>
            
            <p className='dialog__heading'>Are you sure you want to block this person?</p>
            <div className="flex mt-2 mb-2 justify-content-center" >
                <Button label="Cancel" className="Btn__Transparent" style={{width:'160px'}} onClick={()=>onHideBlockDialog()}/>
                <Button label="Block" className="Btn__Send ml-2" style={{width:'160px'}}/>
            </div>
        </>
    );
}

export default BlockDialog;
